import React from 'react'

const RequestUpdateContext = React.createContext({})

export default RequestUpdateContext
